import store from '@/store/store';
import axios from 'axios';
import { handleHttpError } from '@/shared/auth/errorHandler';

export function extrairErrosDeBlob(text) {
    const fallback = 'Erro ao obter arquivo ou arquivo inexistente.';
    if (!text?.trim()) {
        return [fallback];
    }
    try {
        const json = JSON.parse(text);
        if (json?.errors?.mensagens?.length) {
            return [...json.errors.mensagens];
        }
        /* Endpoints de download devolvem errors como array plano. */
        if (Array.isArray(json?.errors) && json.errors.length) {
            return [...json.errors];
        }
        if (typeof json?.message === 'string' && json.message.trim()) {
            return [json.message];
        }
        if (typeof json?.title === 'string' && json.title.trim()) {
            return [json.title];
        }
    } catch {
        /* corpo não é JSON */
    }
    return [text.trim()];
}

export const axiosJwt = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosJwt.interceptors.request.use(
    (config) => {
        const token = store.getters.getToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosJwt.interceptors.response.use(
    (response) => {
        return { success: true, data: response.data };
    },
    (error) => {
        const res = error.response;
        /** Com responseType blob, 400/404 vêm como Blob (ex.: ASP.NET NotFound("texto")). */
        if (res?.config?.responseType === 'blob' && (res.status === 404 || res.status === 400)) {
            const payload = res.data;
            if (payload instanceof Blob) {
                if (payload.size === 0) {
                    return Promise.resolve({
                        success: false,
                        errors: [res.status === 404 ? 'Arquivo não encontrado.' : 'Não foi possível concluir a operação.'],
                    });
                }
                return payload.text().then((text) => {
                    const erros = extrairErrosDeBlob(text);
                    return { success: false, errors: erros };
                });
            }
        }

        if (error.config?.sebraeSilentError) {
            const classification = handleHttpError(error);
            const list = Array.isArray(classification.messages) ? classification.messages : ['Erro na requisição.'];
            return Promise.resolve({
                success: false,
                errors: list,
                status: classification.status,
                variant: classification.variant,
            });
        }

        const classification = handleHttpError(error);
        const errors = Array.isArray(classification.messages) ? classification.messages : ['Erro na requisição.'];
        return Promise.resolve({
            success: false,
            errors,
            status: classification.status,
            variant: classification.variant,
        });
    }
);
